import {
  Button,
  Modal,
  Card,
  Spin,
  Row,
  Col,
  message,
  Table,
  Descriptions,
  Tag,
  Space,
  Divider,
  Input,
} from "antd";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { getSchemaContractOptions } from "../constant/SchemaOption";
import { HEADERS_EXPORT_BEN, POST_DATA_RE_PRINT } from "../../../API/apiUrls";
import dayjs from "dayjs";
import { optionsLocat } from "../../../../utils/constant/LocatOption";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import { cancelCodeOptions } from "../constant/CancelCodeOption";
import { PrinterOutlined } from "@ant-design/icons";
import { createPdfRePrintAcc2And8 } from "../export/ExportRePrintAcc2And8";
import { createPdfRePrintAcc1 } from "../export/ExportRePrintAcc1";
import { createPdfRePrintAcc3 } from "../export/ExportRePrintAcc3";

const SelectDataForRePrint = ({ open, close, dataRecord }) => {
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const userCompany = localStorage.getItem("COMPANY_ID");
  const contractOptions = getSchemaContractOptions(userCompany);
  const [loading, setLoading] = useState(false);
  const [arrayTableRePrint, setArrayTableRePrint] = useState([]);
  const [arrDataRePrint, setArrDataRePrint] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (!open || !dataRecord) return;

    loadDataRePrint(dataRecord);
  }, []);

  const loadDataRePrint = async (data) => {
    console.log(data);
    setLoading(true);
    const payload = {
      docTime: data.docTime,
      forCode: data.forCode,
      gcode: data.gcode,
      dataType: data.dataType,
    };
    console.log(payload);
    console.log(HEADERS_EXPORT_BEN);

    try {
      const { data, status } = await axios.post(POST_DATA_RE_PRINT, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (
        status !== 200 ||
        !data ||
        (Array.isArray(data) && data.length === 0)
      ) {
        message.warning("ไม่มีข้อมูล");
        return;
      }

      console.log("res data", data);
      filterData(data);
    } catch (error) {
      const status = error?.response?.status;
      const serverMsg = error?.response?.data?.message;
      console.error("API error:", status, serverMsg || error.message);
      message.error(serverMsg || `ไม่สามารถดึงข้อมูลได้ (${status ?? " - "})`);
    } finally {
      setLoading(false);
    }
  };

  const contractLabelByValue = useMemo(() => {
    return Object.fromEntries(
      (contractOptions ?? []).map((o) => [o.value, o.label])
    );
  }, [contractOptions]);

  const { forMap, gMap } = useMemo(() => {
    const fm = {}; // map: FORCODE -> label
    const gm = {}; // map: GCODE  -> label (ถ้า GCODE ซ้ำข้ามกลุ่ม ให้ดูตัวอย่างล่าง)
    cancelCodeOptions.forEach((parent) => {
      fm[parent.value] = parent.label;
      parent.children?.forEach((ch) => {
        gm[ch.value] = ch.label;
      });
    });
    return { forMap: fm, gMap: gm };
  }, []);

  const filterData = (value) => {
    if (Array.isArray(value)) {
      let filteredDataCompany;

      if (userCompany === "3") {
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return true;
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.CONTNO.includes("UD")
          );
        });
      } else {
        filteredDataCompany = value.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false;
          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }
      // dataContractUse = บช.ภายในตัดหนี้ 0
      let dataContractUse = filteredDataCompany.filter(
        (item) =>
          item.CONTNO?.substring(0, 1) !== "5" &&
          item.CONTNO?.substring(0, 1) !== "6" &&
          item.CONTNO?.substring(0, 1) !== "7"
      );

      let customData = mergeDataWithGuarantors(dataContractUse);
      console.log("dataContractUse", customData);
      setArrDataRePrint(customData);
      setArrayTableRePrint(customData);
      setLoading(false);
    }
  };

  const mergeDataWithGuarantors = (data) => {
    console.log("mergeDataWithGuarantors");
    let mergedData;
    if (dataRecord.dataType !== "lsfhp") {
      mergedData = data.reduce((acc, record) => {
        const mainData = (record.address || []).map((addr) => ({
          ...record,
          cusType: 0,
          GCODE: record.GCODE,
          REGNO: record.REGNO,
          CONTNO: record.CONTNO, // เพิ่ม CONTNO ให้ชัดเจน
          NAME: `${record.SNAM} ${record.NAME1 || ""} ${
            record.NAME2 || ""
          }`.trim(),
          address: addr,
        }));

        const guarantorData = (record.guarantors || []).flatMap((guarantor) =>
          (guarantor.address || []).map((addr) => ({
            ...record,
            cusType: parseInt(guarantor.GARNO),
            NAME: `${guarantor.SNAM} ${guarantor.NAME1} ${guarantor.NAME2}`.trim(),
            address: addr,
          }))
        );

        return [...acc, ...mainData, ...guarantorData];
      }, []);
    } else {
      mergedData = data.reduce((acc, record) => {
        const mainData = (record.address || []).map((addr) => ({
          ...record,
          cusType: 0,
          GCODE: record.GCODE,
          REGNO: record.REGNO,
          CONTNO: record.CONTNO, // เพิ่ม CONTNO ให้ชัดเจน
          NAME: `${record.SNAM} ${record.NAME1 || ""} ${
            record.NAME2 || ""
          }`.trim(),
          address: addr,
        }));
        return [...acc, ...mainData];
      }, []);
    }

    // เรียงลำดับ CONTNO ก่อน แล้ว GARNO ทีหลัง
    const sortedData = mergedData.sort((a, b) => {
      const contnoComparison = a.DOCNO.localeCompare(b.DOCNO, undefined, {
        numeric: true,
      });
      if (contnoComparison !== 0) return contnoComparison; // เรียงตาม CONTNO ก่อน

      return (a.cusType || 0) - (b.cusType || 0); // GARNO: 0 (ลูกค้าหลัก) จะมาก่อน, จากนั้นเรียง 1, 2, 3...
    });

    // เพิ่ม key ให้แต่ละ record เริ่มจาก 1
    return sortedData.map((item, index) => ({
      ...item,
      key: index + 1, // เริ่ม key จาก 1
    }));
  };

  const onSearch = (value) => {
    setLoading(true);
    let result;
    const vlaueTrim = value.trim();

    if (value) {
      result = arrayTableRePrint.filter(
        (item) =>
          (item.CONTNO && item.CONTNO.includes(vlaueTrim)) ||
          (item.NAME && item.NAME.includes(vlaueTrim)) ||
          (item.REGNO && item.REGNO.includes(vlaueTrim))
      );
    } else {
      result = arrDataRePrint;
    }

    setTimeout(() => {
      setLoading(false);
    }, 250);
    setArrayTableRePrint(result);
  };

  const handleCancel = () => {
    close(false);
  };

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);
    console.log("Selected Row Keys:", selectedRowKeys); // คีย์ของแถวที่เลือก
    console.log("Selected Rows Data:", selectedRows); // ข้อมูลของแถวที่เลือก
    setSelectedRows(selectedRows); // เก็บข้อมูลแถวที่เลือกใน state;
  };

  const handleRePrint = async () => {
    setLoading(true);
    let useData = selectedRows.length > 0 ? selectedRows : arrayTableRePrint;
    console.log("useData", useData);

    try {
      console.log("dataRecord.dataType", dataRecord.dataType);

      if (dataRecord.dataType === "lsfhp") {
        await createPdfRePrintAcc1(useData);
      } else if (
        dataRecord.dataType === "vsfhp" ||
        dataRecord.dataType === "sfhp"
      ) {
        await createPdfRePrintAcc2And8(useData);
      } else {
        createPdfRePrintAcc3(useData);
      }

      message.success("โหลด Excel สำเร็จ");
    } catch (e) {
      console.error(e);
      message.error(`พิมพ์ไม่สำเร็จ: ${e?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (rowKeys, selectedRows) => {
      onSelectChange(rowKeys, selectedRows);
    },
  };

  const columnsData = [
    {
      title: "ลำดับ",
      key: "key", // ใช้ key แทน dataIndex เพราะเราไม่ต้องการใช้ข้อมูลจาก data
      align: "center",
      render: (text, record, index) => (
        <>{record.key}</> // ใช้ index ที่ถูกส่งมาจาก Table เพื่อเพิ่มลำดับแถว
      ),
    },
    {
      title: "วันที่ออกจดหมาย",
      align: "center",
      render: (record) => (
        <>
          {record.DOCDT
            ? dayjs(record.DOCDT).add(543, "year").format("D MMM YY")
            : null}
        </>
      ),
    },

    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER",
      key: "CUSTOMER",
      align: "center",
      render: (text, record) => <>{record.NAME ? record.NAME : null}</>,
    },
    {
      title: "ประเภทลูกค้า",
      align: "center",
      render: (text, record) => (
        <>
          {record.cusType === 0 ? "ผู้เช่าซื้อ" : `ผู้ค้ำที่ ${record.cusType}`}
        </>
      ),
    },
    {
      title: "ที่อยู่",
      dataIndex: "address",
      key: "address",
      align: "center",
      render: (text, record) => (
        <>
          {record.address.ADDR} <br />
          {record.address.MOOBAN}
          <br />
          {record.address.AUMPDES} {record.address.PROVDES} <br />
          {record.address.ZIP}
        </>
      ),
    },
    {
      title: "รายละเอียดรถ",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <>
          {record.TYPE} <br />
          {record.REGNO}
        </>
      ),
    },

    {
      title: "ค้างงวด",
      dataIndex: "EXP_PRD",
      key: "EXP_PRD",
      align: "center",
    },
    {
      title: "เงินค้าง",
      align: "center",
      render: (text, record) => (
        <>
          {currencyFormatPoint(record.TOTPRC - record.SMPAY)} <br />
        </>
      ),
    },
    {
      title: "ค่าทวงถาม",
      align: "center",
      render: (text, record) => <>{currencyFormatComma(record.LETTER)}</>,
    },
  ];

  return (
    <>
      <Modal
        title="เลือกข้อมูล รีปริ้นท์"
        name="SelectDataForRePrint"
        open={open}
        onCancel={handleCancel}
        width={"auto"}
        footer={[
          <Button
            danger
            key="close"
            style={{ color: "red" }}
            onClick={handleCancel}
          >
            ปิด
          </Button>,
        ]}
        style={{ padding: "20px" }}
      >
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Card>
            <Divider
              orientation="center"
              style={{ marginTop: 0, marginBottom: 12 }}
            >
              รายละเอียดรอบที่เลือก
            </Divider>

            <div style={{ overflowX: "auto" }}>
              <Descriptions
                size="small"
                column={4}
                colon
                label={{ fontWeight: 600, whiteSpace: "nowrap" }}
                style={{ whiteSpace: "nowrap" }} // <<< กันตัดขึ้นบรรทัดใหม่
              >
                <Descriptions.Item label="สัญญา">
                  <Tag color="geekblue">
                    {contractLabelByValue?.[dataRecord?.dataType] ?? "-"}
                  </Tag>
                </Descriptions.Item>

                <Descriptions.Item label="รอบวันที่">
                  {dataRecord?.docTime
                    ? dayjs(dataRecord.docTime)
                        .add(543, "year")
                        .format("D MMM YYYY")
                    : "-"}
                </Descriptions.Item>

                <Descriptions.Item label="F CODE">
                  <Tag>
                    {forMap?.[dataRecord?.forCode] ??
                      dataRecord?.forCode ??
                      "-"}
                  </Tag>
                </Descriptions.Item>

                <Descriptions.Item label="G CODE">
                  <Tag>
                    {gMap?.[dataRecord?.gcode] ?? dataRecord?.gcode ?? "-"}
                  </Tag>
                </Descriptions.Item>
              </Descriptions>
            </div>

            <Row>
              <Col
                span={"12"}
                style={{ textAlign: "start", marginTop: "20px" }}
              >
                <Button
                  type="text"
                  icon={
                    <PrinterOutlined
                      style={{
                        fontSize: "24px",
                      }}
                    />
                  }
                  onClick={handleRePrint}
                  color="orange"
                  variant="outlined"
                  loading={loading}
                >
                  พิมพ์
                </Button>
              </Col>
              <Col span={"12"} style={{ textAlign: "end" }}>
                <Space size={16} style={{ marginTop: "20px" }}>
                  <Input.Search
                    placeholder="ค้นหาสัญญา"
                    enterButton
                    onSearch={onSearch}
                    style={{
                      width: "auto",
                      borderRadius: "8px",
                    }}
                    size="large"
                  />
                </Space>
              </Col>
              <Col
                span={"24"}
                style={{ textAlign: "center", marginTop: "10px" }}
              >
                <Table
                  style={{ marginTop: "10px" }}
                  size="small"
                  columns={columnsData}
                  dataSource={arrayTableRePrint}
                  scroll={{ x: 850 }}
                  rowSelection={rowSelection}
                  rowKey={(row) => row.key || row.id || row.DOCNO}
                  footer={() => <p>จำนวน {arrayTableRePrint.length}</p>}
                />
              </Col>
            </Row>
          </Card>
        </Spin>
      </Modal>
    </>
  );
};
export default SelectDataForRePrint;
